// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cognitoUserPoolId: "us-east-2_fZtm68jBR",
  cognitoAppClientId: "3vo1n07qmqj9ucnk0bh08b2f8l",
  constantsS3Bucket: "https://avaeleconstantsbucket.s3.us-east-2.amazonaws.com/",
  backend: "http://avaelebackend2.us-east-2.elasticbeanstalk.com/",
  dev_backend: "http://localhost:8080/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
